export default __webpack_public_path__ + "static/twitter-5e2e3546978438f0e37b253b12537f5a.png";